import { WorkspaceInterface } from '@reach/interfaces/workspaces/workspace.interface';
import { GetWorkspacesResponse } from '@reach/interfaces/workspaces/workspaces.responses';

import { sortWorkspacesAlphabeticallyImmutable } from '~ng-common-lib/workspaces/sort-workspaces';
import {
	workspaceTrashedNodesTransformer,
	workspaceUnassignedNodesTransformer,
} from '~ng-common-lib/workspaces/utils/extra-workspaces.utils';
import { ClientWorkspace, ClientWorkspaceType } from '~ng-common-lib/workspaces/workspace.type';

export function sortWorkspacesForDisplay(workspaces: ClientWorkspace[]): ClientWorkspace[] {
	const specialTypes = [ClientWorkspaceType.UNASSIGNED_NODES, ClientWorkspaceType.TRASHED_NODES];

	return [...workspaces].sort((a, z) => {
		const aSpecial = specialTypes.includes(a.type);
		const zSpecial = specialTypes.includes(z.type);

		if (aSpecial !== zSpecial) {
			return aSpecial ? -1 : 1;
		}

		return a.name.localeCompare(z.name);
	});
}

export function parseWorkspacesFromGetAllResponse(
	response: GetWorkspacesResponse
): ClientWorkspace[] {
	const normalWorkspaces = sortWorkspacesAlphabeticallyImmutable(
		response.all.map((workspace) => parseWorkspaceFromServer(workspace))
	);

	return [
		workspaceUnassignedNodesTransformer(response.unassigned.count),
		workspaceTrashedNodesTransformer(response.trash.count),
		...normalWorkspaces,
	];
}

function parseWorkspaceFromServer(
	workspace: WorkspaceInterface & { count: number }
): ClientWorkspace {
	return {
		id: workspace.id,
		name: workspace.name,
		description: workspace.description ?? '',
		type: ClientWorkspaceType.NORMAL,
		count: workspace.count,
		emoji: workspace.emoji,
		thumbnailUrl: workspace.thumbnailUrl,
	};
}
